module.exports = __webpack_public_path__ + "static/media/lumbering26.54ab7d95.jpg";